<div class="payments {{ couleurIndicateur }}">
  <div class="payments-thermometer">
    <img
      *ngIf="hasThermometre"
      src="{{ 'assets/images/risques/thermometre-' + couleurIndicateur + '.svg' | cheminAbsoluStatique }}"
      alt=""
      class="payments-thermometer-icon"
    />
    <div class="payments-thermometer-content" [ngClass]="{ 'no-icon': !hasThermometre }">
      <div class="payments-thermometer-content-title dsd-mb-0">{{ texteIndicateur | translate }}</div>
      <p class="payments-thermometer-content-text">
        <span
          [innerHTML]="
            'propriete.detail.thermometre.prix-de-propriete'
              | translate: { prix: currentProperty.prixTotal | desjardinsCurrency }
          "
        ></span>
        <button
          (click)="editProperty()"
          id="payments-thermometer-button-edit-property"
          class="payments-thermometer-content-btn no-border"
          [attr.aria-label]="'propriete.detail.thermometre.modifier' | translate"
        >
          <img src="{{ 'assets/images/edit.svg' | cheminAbsoluStatique }}" alt="" />
        </button>
      </p>
      <p *ngIf="currentProperty.propriete.montantFraisRenovations" class="payments-thermometer-content-text frais-reno">
        <span
          [innerHTML]="
            'propriete.detail.frais-renovation'
              | translate: { frais: currentProperty.propriete.montantFraisRenovations | desjardinsCurrency }
          "
        ></span>
        <button
          (click)="editProperty()"
          id="payments-thermometer-button-edit-reno"
          class="payments-thermometer-content-btn no-border"
          [attr.aria-label]="'propriete.detail.thermometre.modifier' | translate"
        >
          <img src="{{ 'assets/images/edit.svg' | cheminAbsoluStatique }}" alt="" />
        </button>
      </p>
      <div
        *ngIf="!currentProperty.propriete.montantFraisRenovations"
        class="payments-thermometer-content-text reno-fees"
      >
        <button id="propriete.detail.paiement-mensuel.ajouter-frais" class="text-only-button" (click)="editProperty()">
          {{ 'propriete.detail.paiement-mensuel.ajouter-frais' | translate }}
        </button>
        <app-tooltip
          [ariaLabel]="'propriete.creation.sr-only.infobulle-frais-renovation' | translate"
          class="info-bulle"
          [id]="'frais-renovation-infobulle'"
          [ariaLabel]="'propriete.detail.tooltip.sr-only' | translate"
          [titre]="'propriete.creation.label-frais-renovation' | translate"
          [texte]="'propriete.creation.infobulle-frais-renovation' | translate"
          [placement]="'bottom'"
        ></app-tooltip>
      </div>
    </div>
  </div>

  <div class="payments-content" *ngIf="hasThermometre">
    <div class="payments-content-montant-mensuel">
      <app-currency-string
        class="payments-content-fees dsd-mb-0"
        [value]="
          currentProperty.propriete.analyseEcartPrequalification.montantVersementMensuel +
          currentProperty.montantFraisMensuels
        "
        [periodicity]="'general.par-mois' | translate"
        [id]="'montant-mensuel'"
      ></app-currency-string>
      <app-tooltip
        class="info-bulle"
        [ariaLabel]="'propriete.detail.tooltip.montant-mensuel-sr-only' | translate"
        [id]="'paiement-hypothecaire.montant-mensuel.idInfobulle'"
        [titre]="'propriete.detail.tooltip.titre' | translate"
        [texte]="'propriete.detail.tooltip.description' | translate: paymentTerms"
        [placement]="'bottom'"
      ></app-tooltip>
    </div>
    <p
      class="payments-content-part dsd-mb-0"
      [innerText]="
        (currentProperty.hasRenovations
          ? 'propriete.detail.paiement-mensuel.montant-total-avec-reno'
          : 'propriete.detail.paiement-mensuel.montant-total'
        ) | translate
      "
    ></p>
    <p class="payments-content-part">
      <app-currency-string
        class="payments-content-part-fees"
        [value]="currentProperty.propriete.analyseEcartPrequalification.montantVersementMensuel"
        [periodicity]="'general.par-mois' | translate"
        [id]="'montant-mensuel'"
      ></app-currency-string>
      <span
        [innerHTML]="
          (currentProperty.hasPrimeAssureur
            ? 'propriete.detail.paiement-mensuel.paiement-hypothecaire-avec-prime'
            : 'propriete.detail.paiement-mensuel.paiement-hypothecaire'
          ) | translate
        "
      ></span>
    </p>
  </div>

  <div class="cas-particulier-content" id="mise-fonds-insuffisante-content" *ngIf="isMiseDeFondsInsuffisante">
    <div class="content-text">
      <p
        class="mise-fonds-text"
        [innerHTML]="
          'propriete.detail.mise-fonds-insuffisante-1'
            | translate
              : {
                  miseFondsRequise: miseDeFondsRequise | desjardinsCurrency,
                  fondsManquants: fondsManquants | desjardinsCurrency
                }
        "
      ></p>
      <p class="mise-fonds-text">
        {{ 'propriete.detail.mise-fonds-insuffisante-2' | translate
        }}<a class="link" routerLink="/capacite">{{ 'propriete.detail.mise-fonds-insuffisante-lien-cf' | translate }}</a
        >{{ 'propriete.detail.mise-fonds-insuffisante-3' | translate }}
      </p>
    </div>
    <app-boite-contact buttonStyle="textOnly"></app-boite-contact>
  </div>

  <div class="cas-particulier-content" id="budget-insuffisant-content" *ngIf="isBudgetInsuffisant">
    <p class="content-text">
      {{ 'propriete.detail.budget-insuffisant-1' | translate
      }}<a class="link" routerLink="/capacite">{{ 'propriete.detail.budget-insuffisant-lien-cf' | translate }}</a
      >{{ 'propriete.detail.budget-insuffisant-2' | translate
      }}<app-boite-contact
        buttonStyle="textOnly"
        buttonText="propriete.detail.budget-insuffisant-lien-ctcmb"
      ></app-boite-contact>
    </p>
    <button class="edit-capacite-financiere text-only-button" (click)="editCapaciteFinanciere()">
      {{ 'propriete.detail.modifier-capacite' | translate }}
    </button>
  </div>

  <div class="cas-particulier-content" id="budget-important-content" *ngIf="isBudgetImportant">
    <div class="content-text">
      <p class="budget-important-text" [innerHTML]="'propriete.detail.budget-important-1' | translate"></p>
      <p class="budget-important-text" [innerHTML]="'propriete.detail.budget-important-2' | translate"></p>
    </div>

    <app-boite-contact buttonStyle="textOnly"></app-boite-contact>
  </div>
</div>
